import React, { useState } from 'react';

import {
    TableContainer,
    Table,
    Paper,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Switch,
    Collapse
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { makeStyles } from '@material-ui/core/styles';
import Utils from '@/common/utils/utils';
import { updateUserById } from '@/service/userService';
import { useRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import { cloneDeep } from 'lodash';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';

const useStyles = makeStyles(() => ({
    root: {
        width: 54,
        height: 38
    },
    switchBase: {
        padding: 12,
        '&$checked': {
            transform: 'translateX(16px)',
            color: 'white',
            '& + $track': {
                backgroundColor: '#2b659d',
                opacity: 1,
                border: 'none'
            }
        },
        '&$focusVisible $thumb': {
            color: 'red',
            border: '6px solid #fff'
        }
    },
    thumb: {
        width: 13,
        height: 13
    },
    track: {
        border: `1px solid gray`,
        backgroundColor: 'gray',
        opacity: 1
    },
    checked: {},
    focusVisible: {}
}));

const changeLabel = (label) =>{
    if(label== 'チケット'){
        return 'チケットに関する通知を許可'
    }
    if(label== 'チャット'){
        return 'チャットに関する通知を許可'
    }
    if(label=='ユーザーID'){
        return 'ユーザーIDに関する通知を許可'
    }
    return label
}

function Row(props) {
    const [userDetail, setUserDetail] = useRecoilState(userAtom);
    const { row, handleValueNotification, valueSettingNotification } = props;
    const [open, setOpen] = useState(false);
    const classes = useStyles();

    const handleSubmitChangeSetting = async (event, type, currentValue) => {
        let updateSetting = { ...currentValue };
        let nameElt = event.target.name;
        let valueElt = event.target.checked;
        if (nameElt === 'isSdeskNotification') {
            updateSetting.isSdeskNotification = valueElt;
            if (valueElt) {
                const lastItemIndex = updateSetting.offSdeskNotificationInterval.length - 1;
                updateSetting.offSdeskNotificationInterval[
                    lastItemIndex
                ].turnOn = new Date().getTime();
            } else {
                updateSetting.offSdeskNotificationInterval.push({
                    turnOff: new Date().getTime(),
                    turnOn: 0
                });
            }
        }
        if (nameElt === 'isEmailNotification') {
            updateSetting.isEmailNotification = valueElt;
        }
        if (nameElt === 'isShortMsgNotification') {
            updateSetting.isShortMsgNotification = valueElt;
        }
        let newSetting = { ...JSON.parse(userDetail.settingNotification) };
        let newUserDetail = cloneDeep(userDetail);
        newSetting[`${type}`] = updateSetting;
        newUserDetail.settingNotification = JSON.stringify(newSetting);

        handleValueNotification(event, type, nameElt, valueElt);
        let updateUserInfo = await updateUserById(props?.API, {
            id: userDetail.id,
            settingNotification: JSON.stringify(newSetting)
        });

        // setUserDetail state
        newUserDetail.workSpace = Utils.convertJSONDataToObject(updateUserInfo.workSpace);
        setUserDetail(newUserDetail);
    };

    const handleChange = async (event, type) => {
        switch (type) {
            case 'ticket':
                await handleSubmitChangeSetting(event, type, valueSettingNotification[0]);
                break;
            case 'chatMsg':
                await handleSubmitChangeSetting(event, type, valueSettingNotification[1]);
                break;
            case 'userChange':
                await handleSubmitChangeSetting(event, type, valueSettingNotification[2]);
                break;
            default:
                break;
        }
    };

    return (
        <>
            <TableRow>
                <TableCell component="th" scope="row" className="first-column" align="center">
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {/*  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />} */}
                        </IconButton>
                        <OverFlowTooltipWithTabsMui value={changeLabel(row.label)}/>
                    </div>
                </TableCell>
                <TableCell align="center" className="second-column">
                    <div
                        className='switchSetting'
                    ></div>
                    {/* <Switch
                        className='switchSetting'
                        checked={row.isShortMsgNotification}
                        name="isShortMsgNotification"
                        onChange={event => handleChange(event, row.type)}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        classes={{
                            root: classes.root,
                            switchBase: classes.switchBase,
                            thumb: classes.thumb,
                            track: classes.track,
                            checked: classes.checked
                        }}
                    /> */}
                </TableCell>
                <TableCell align="center" className="third-column">
                <div
                        className='switchSetting'
                    ></div>
                    {/* <Switch
                        className='switchSetting'
                        checked={row.isSdeskNotification}
                        name="isSdeskNotification"
                        onChange={event => handleChange(event, row.type)}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        classes={{
                            root: classes.root,
                            switchBase: classes.switchBase,
                            thumb: classes.thumb,
                            track: classes.track,
                            checked: classes.checked
                        }}
                    /> */}
                </TableCell>
                <TableCell align="center" className="third-column">
                    <Switch
                        className='switchSetting'
                        checked={row.isEmailNotification}
                        name="isEmailNotification"
                        onChange={event => handleChange(event, row.type)}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        classes={{
                            root: classes.root,
                            switchBase: classes.switchBase,
                            thumb: classes.thumb,
                            track: classes.track,
                            checked: classes.checked
                        }}
                    />
                </TableCell>
                <TableCell align="center" className="fourth-column">
                <div
                        className='switchSetting'
                    ></div>
                    {/* <Switch
                        className='switchSetting'
                        checked={row.isShortMsgNotification}
                        name="isShortMsgNotification"
                        onChange={event => handleChange(event, row.type)}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        classes={{
                            root: classes.root,
                            switchBase: classes.switchBase,
                            thumb: classes.thumb,
                            track: classes.track,
                            checked: classes.checked
                        }}
                    /> */}
                </TableCell>
                <TableCell align="center" className="fifth-column">
                <div
                        className='switchSetting'
                    ></div>
                    {/* <Switch
                        className='switchSetting'
                        checked={row.isSlackNotification}
                        name="isSlackNotification"
                        onChange={event => handleChange(event, row.type)}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        classes={{
                            root: classes.root,
                            switchBase: classes.switchBase,
                            thumb: classes.thumb,
                            track: classes.track,
                            checked: classes.checked
                        }}
                    /> */}
                </TableCell>
                <TableCell align="center" className="sixth-column">
                <div
                        className='switchSetting'
                    ></div>
                    {/* <Switch
                        className='switchSetting'
                        checked={row.isGoogleChatNotification}
                        name="isGoogleChatNotification"
                        onChange={event => handleChange(event, row.type)}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        classes={{
                            root: classes.root,
                            switchBase: classes.switchBase,
                            thumb: classes.thumb,
                            track: classes.track,
                            checked: classes.checked
                        }}
                    /> */}
                </TableCell>
            </TableRow>

            {/* row collapse */}
           {/*  <TableRow>
                <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={6}
                    className="tableCollapse"
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Table aria-label="purchases">
                            <TableBody>
                                {row.eventsChild?.map(item => (
                                    <TableRow key={item.type}>
                                        <TableCell className="first-column">{item.label}</TableCell>
                                        <TableCell className="second-column">
                                            <Switch
                                                className='switchSetting'
                                                disabled
                                                checked={item.isEmailNotification}
                                                name="isEmailNotification"
                                                onChange={event => {}}
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                classes={{
                                                    root: classes.root,
                                                    switchBase: classes.switchBase,
                                                    thumb: classes.thumb,
                                                    track: classes.track,
                                                    checked: classes.checked
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell className="third-column">
                                            <Switch
                                                className='switchSetting'
                                                disabled
                                                checked={item.isSdeskNotification}
                                                name="isSdeskNotification"
                                                onChange={event => {}}
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                classes={{
                                                    root: classes.root,
                                                    switchBase: classes.switchBase,
                                                    thumb: classes.thumb,
                                                    track: classes.track,
                                                    checked: classes.checked
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="center" className="fourth-column">
                                            <Switch
                                                className='switchSetting'
                                                disabled
                                                checked={item.isShortMsgNotification}
                                                name="isShortMsgNotification"
                                                onChange={event => {}}
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                classes={{
                                                    root: classes.root,
                                                    switchBase: classes.switchBase,
                                                    thumb: classes.thumb,
                                                    track: classes.track,
                                                    checked: classes.checked
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="right" className="fifth-column">
                                            <Switch
                                                className='switchSetting'
                                                disabled
                                                checked={item.isSlackNotification}
                                                name="isSlackNotification"
                                                onChange={event => {}}
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                classes={{
                                                    root: classes.root,
                                                    switchBase: classes.switchBase,
                                                    thumb: classes.thumb,
                                                    track: classes.track,
                                                    checked: classes.checked
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="center" className="sixth-column">
                                            <Switch
                                                className='switchSetting'
                                                disabled
                                                checked={item.isGoogleChatNotification}
                                                name="isGoogleChatNotification"
                                                onChange={event => {}}
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                classes={{
                                                    root: classes.root,
                                                    switchBase: classes.switchBase,
                                                    thumb: classes.thumb,
                                                    track: classes.track,
                                                    checked: classes.checked
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Collapse>
                </TableCell>
            </TableRow> */}
        </>
    );
}
const getInitValueSettingNotification = settingNotification => {
    let settingNotificationObj = {};
    let initValueSettingNotification = [];
    try {
        settingNotificationObj = JSON.parse(settingNotification);
    } catch (err) {
        console.log('error :>> ', err);
    }
    if (!Utils.isEmptyObject(settingNotificationObj)) {
        initValueSettingNotification[0] = settingNotificationObj.ticket;
        initValueSettingNotification[1] = settingNotificationObj.chatMsg;
        initValueSettingNotification[2] = settingNotificationObj.userChange;
    }
    return initValueSettingNotification;
};

export default function PersonalSettingTab({ userDetail, API }) {
    const [valueSettingNotification, setValueSettingNotification] = useState([
        ...getInitValueSettingNotification(userDetail.settingNotification)
    ]);

    const handleValueNotification = (event, type, nameElt, valueElt) => {
        // console.log('valueElt', event, type, nameElt, valueElt);
        let result = valueSettingNotification;
        for (let i = 0; i < result.length; i++) {
            if (result[i].type === type) {
                result[i] = {
                    ...result[i],
                    [nameElt]: valueElt
                };
            }
        }
        setValueSettingNotification([...valueSettingNotification]);
    };

    return (
        <div className="settingFrame scrollTab customScroll">
            {/* <h2 className="title">■ 個人設定</h2> */}
            <div className="personalSetting-table">
                <TableContainer component={Paper} className="table-container">
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow className="tableHeader">
                                <TableCell align="center" className="first-column"></TableCell>
                                <TableCell align="center" className="second-column">
                                    <div className="thCellFrame">
                                        {/* <img src="/assets/image/icon-sms.png" alt="" />
                                        <span className="settingName">Short msg</span> */}
                                    </div>
                                </TableCell>
                                <TableCell align="center" className="third-column">
                                    <div className="thCellFrame">
                                      {/*  <img src="/assets/image/icon-sdesk.png" alt="" />
                                        <span className="settingName">SolutionDesk</span> */}
                                    </div>
                                </TableCell>
                                <TableCell align="center" className="fourth-column">
                                    <div className="thCellFrame">
                                        <MailOutlineIcon fontSize="small" />
                                        <span className="settingName">Email</span>
                                    </div>
                                </TableCell>
                                <TableCell align="center" className="fifth-column">
                                    <div className="thCellFrame">
                                      {/*   <img src="/assets/image/icon-slack.png" alt="" />
                                        <span className="settingName">Slack</span> */}
                                    </div>
                                </TableCell>
                                <TableCell align="center" className="sixth-column">
                                    <div className="thCellFrame">
                                        {/* <img src="/assets/image/icon-google-chat.png" alt="" />
                                        <span className="settingName">Google Chat</span> */}
                                    </div>
                                </TableCell>
                                <TableCell align="center" className="sixth-column">
                                    <div className="thCellFrame">
                                        {/* <img src="/assets/image/icon-google-chat.png" alt="" />
                                        <span className="settingName">Google Chat</span> */}
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {valueSettingNotification?.map(itemRow => (
                                <Row
                                    key={itemRow.type}
                                    row={itemRow}
                                    handleValueNotification={handleValueNotification}
                                    valueSettingNotification={valueSettingNotification}
                                    userDetail={userDetail}
                                    API={API}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}
